import { LitElement, html, css } from 'lit';
import { validateForm, validatePassword, gRecaptcha, validationHandler, validationHandlerClear, hideRevealPassword } from '../../utilities/formsUtilities';
import { accessibility, formStyles } from '../../utilities/styles';
import { eyeSvg } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
export class AllInResetPasswordForm extends LitElement {
    static properties = {
        action: { type: String },
        nonce: { type: String },
        alreadyLoggedInMessage: { type: String },
        loggedIn: { type: String },
        passwordReset: { type: Boolean },
        retry: { type: String },
        hardlinks: { type: Object },
        _code: { state: true, type: String },
        _errorMessage: { state: true, type: String },
        _resetSuccess: { state: true, type: String },
        _resetError: { state: true, type: String },
    };
    constructor() {
        super();
        this.eventManager = new EventManager(this);
        setTimeout(() => {
            this.eventManager.emit('allin-login', { loggedOut: true });
        }, 100);
        document.cookie = "allin-uid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        this.loggedIn = 'false';
        this._resetSuccess = false;
        this._errorMessage = '';
        let queryString = window.location.search;
        let params = new URLSearchParams(queryString);
        this.token = params.get('token_hash');
        if (this.token) {
            this._code = this.token;
            this._hashType = 'token_hash';
        }
        else {
            let codeHash = window.location.hash;
            if (codeHash) {
                let code = codeHash.substring(1);
                if (code.includes('access_token')) {
                    let params = new URLSearchParams(code);
                    this._code = params.get('access_token');
                    this._hashType = 'access_token';
                }
                else if (code.includes('error')) {
                    if (code_message.includes('otp_expired')) {
                        this._resetError = html `<p>The link you followed has expired.</p>\n                    <p>If you weren't expecting this link to be expired, please contact your IT department to check if this domain (https://allin.online) is in the allowlist.</p>\n                    <p><a href="${this.hardlinks['verify_your_email']}">Please request a new one</a></p>`;
                    }
                    else {
                        let params = new URLSearchParams(code);
                        this._resetError = params.get('error_description') || 'An error occurred while resetting your password. Please try again later.';
                    }
                    this._code = false;
                }
            }
        }
    }
    get form() {
        return this.shadowRoot.querySelector('form');
    }
    get formResponse() {
        return this.shadowRoot.querySelector('.message');
    }
    get submitButton() {
        return this.shadowRoot.querySelector('input[type="submit"]');
    }
    render() {
        let markup;
        if (this.loggedIn == 'true') {
            markup = html `\n                <p>${this.alreadyLoggedInMessage}</p>\n            `;
        }
        else if (this._resetError) {
            markup = html `\n                <div class="error">\n                    <h3>Error resetting password</h3>\n                    <p>${this._resetError}</p>\n                    <p><a href="${this.retry}">Retry</a></p>\n                </div>\n            `;
        }
        else if (this.passwordReset && this._code) {
            markup = html `\n                <form action="${this.action}-new" method="post" @submit=${this._reset}>\n                    <div class="form_inner ${this._resetSuccess ? 'hide' : ''}" >\n                        <div class="message notice" aria-live="polite"></div>\n                         <div class="input-group">\n                            <label for="password">New password*</label>\n                            <div class="pword_wrapper">\n                                <input type="password" name="password" id="password" aria-required @change=${this._onPasswordChange}>\n                                <button data-switch="password" aria-label="Show password" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>\n                                ${eyeSvg}Show password</button>\n                            </div>\n                        </div>\n                        <div class="input-group">\n                            <label for="password_confirm">Confirm password*</label>   \n                            <div class="pword_wrapper">\n                                <input type="password" name="password_confirm" id="password_confirm" aria-required @change=${this._onPasswordConfirmChange}>\n                                <button data-switch="password_confirm" aria-label="Show password" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>\n                               ${eyeSvg} Show password</button>\n                            </div>\n                        </div>\n                        <input type="hidden" name="code" value="${this._code}">\n                        <input type="hidden" name="hash_type" value="${this._hashType}">\n                        <input type="text" name="login" id="login" class="hp" autocomplete="off">\n                        <input type="submit" value="Submit">\n                    </div>\n                    <div class="notice" aria-live="assertive">\n                        <div class="${this._errorMessage ? '' : 'hide'} error">${this._errorMessage}</div>\n                        <slot name="success-message" class="${this._resetSuccess ? '' : 'hide'} success"></slot>\n                    </div>\n                </form>\n            `;
        }
        else if (this.passwordReset) {
            window.location.href = '/login';
        }
        else {
            markup = html `\n                <form action="${this.action}" method="post" @submit=${this._reset}>\n                    <div class="form_inner ${this._resetSuccess ? 'hide' : ''}" >\n                        <div class="message notice" aria-live="polite"></div>\n                        <div class="input-group">\n                            <label for="email">Enter your email to reset your password</label>\n                            <input type="email" name="email" id="email" placeholder="Email" aria-required>\n                        </div>\n                        <input type="text" name="login" id="login" class="hp" autocomplete="off">\n                        <input type="submit" value="Submit">\n                    </div>\n                    <div class="notice" aria-live="assertive">\n                        <div class="${this._errorMessage ? '' : 'hide'} error">${this._errorMessage}</div>\n                        <slot name="success-message-email" class="${this._resetSuccess ? '' : 'hide'} success"></slot>\n                    </div>\n                </form>\n                \n            `;
        }
        return html ` \n            <div class="reset-form">\n                <slot name="reset-form-header"></slot>\n                ${markup}\n            </div>\n        `;
    }
    async _reset(e) {
        e.preventDefault();
        this.formResponse.innerHTML = '';
        this.formResponse.classList.remove('error');
        let valid = validateForm(this.form, this.formResponse);
        if (!valid)
            return;
        let formData = new FormData(this.form);
        formData = JSON.stringify(Object.fromEntries(formData));
        this.form.classList.add('loading');
        this.submitButton.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        let gTokenValid = await gRecaptcha(this.formResponse, this.action, this.nonce);
        if (!gTokenValid) {
            this.form.classList.remove('loading');
            this.form.setAttribute('aria-busy', 'false');
            this.submitButton.disabled = false;
            return;
        }
        try {
            let response = await fetch(this.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Reset': 'reset',
                }
            });
            response = await response.json();
            if (response.ok) {
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this._resetSuccess = true;
                this.formResponse.innerHTML = response.message ? response.message : 'Password reset successful. You can now log in with your new password.';
                if (response.redirect) {
                    window.location.href = response.redirect;
                }
            }
            else {
                this.formResponse.innerHTML = response.message;
                this.formResponse.classList.add('error');
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this.submitButton.disabled = false;
            }
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    _onPasswordChange(e) {
        e.preventDefault();
        let passwordField = e.target;
        let form = passwordField.closest('form');
        let submitButton = form.querySelector('input[type="submit"]');
        validationHandlerClear(passwordField);
        let valid = validatePassword(passwordField.value);
        if (valid !== true) {
            let error_message = valid.join('<br>');
            validationHandler(passwordField, error_message);
            submitButton.disabled = true;
        }
        let passwordConfirmField = form.querySelector('#password_confirm');
        if (passwordConfirmField.value) {
            if (passwordField.value !== passwordConfirmField.value) {
                valid = false;
                validationHandler(passwordConfirmField, `Passwords do not match`);
                submitButton.disabled = true;
            }
            else {
                validationHandlerClear(passwordConfirmField);
            }
        }
        if (valid) {
            submitButton.disabled = false;
        }
    }
    _onPasswordConfirmChange(e) {
        e.preventDefault();
        let passwordConfirmField = e.target;
        let form = passwordConfirmField.closest('form');
        let submitButton = form.querySelector('input[type="submit"]');
        validationHandlerClear(passwordConfirmField);
        let passwordField = form.querySelector('#password');
        if (passwordField.value !== passwordConfirmField.value) {
            validationHandler(passwordConfirmField, `Passwords do not match`);
            submitButton.disabled = true;
        }
        else {
            validationHandlerClear(passwordConfirmField);
            submitButton.disabled = false;
        }
    }
    static styles = [
        accessibility,
        formStyles,
        css `
            .reset-form{
                background-color:var(--allin-bg-color,transparent);
                padding:var(--allin-padding,2rem);
                width:680px;
                max-width:85vw;
                margin:0 auto;
            }

        `
    ];
}
